$('br').attr('aria-hidden','true');
$('.footer-section__item.footer-section__item--menu').removeAttr('role').removeAttr('aria-label');

$(document).ready(function() {
    var $divElement = $('#shopify-section-footer');

    var $footerElement = $('<footer></footer>');

    $footerElement.html($divElement.html());

    $footerElement.attr('id', $divElement.attr('id'));

    $divElement.replaceWith($footerElement);
});

$('.footer-section__item.footer-section__item--menu.w-full.md\\:w-1\\/2.lg\\:w-1\\/3 nav.Footer-menu').eq(0).attr('aria-label', 'Footer First Menu');

$('.footer-section__item.footer-section__item--menu.w-full.md\\:w-1\\/2.lg\\:w-1\\/3 nav.Footer-menu').eq(1).attr('aria-label', 'Footer Second Menu');

$('.header-top__account a.header-top__link').eq(0).attr('aria-label', 'Log in, This Link Will open in a new tab.');

$('.header-top__account a.header-top__link').eq(1).attr('aria-label', 'Create account, This Link will Open in a new tab.');


document.addEventListener("DOMContentLoaded", function() {
    var thirdPartyLinks = document.querySelectorAll('p a , .footer-menu__list-item a');

    thirdPartyLinks.forEach(function(link)
 {
        if (isThirdParty(link.href)) {
            link.setAttribute('target', '_blank');

            var existingText = link.textContent.trim();
            var newText = existingText + ', This Link will open in a new tab';
            link.setAttribute('aria-label', newText);
        }
    });

    function isThirdParty(url) {
        return !url.includes('trafalgarstore.com');
    }
});

$(document).ready(function () {
    var existCondition = setInterval(function () {
        if ($('a.stjr-reviews-carousel-attribution__link').length) {
            clearInterval(existCondition);
            runMyFunctionrmvtb();
        }
    }, 200);

    function runMyFunctionrmvtb() {
        $('a.stjr-reviews-carousel-attribution__link').removeAttr('aria-hidden');
    }
});

$(document).ready(function () {
    var existCondition = setInterval(function () {
        if ($('p.stjr-review__content').length) {
            clearInterval(existCondition);
            runMyFunctionrmvtb2();
        }
    }, 200);

    function runMyFunctionrmvtb2() {
        $('p.stjr-review__content').removeAttr('aria-level');
    }
});

$(document).ready(function () {
    var existCondition = setInterval(function () {
        if ($('.summary-card-container').length) {
            clearInterval(existCondition);
            runMyFunctionrmvtb3();
        }
    }, 200);

    function runMyFunctionrmvtb3() {
        $('.summary-card-container').removeAttr('lang');
    }
});


$(document).ready(function () {
    setTimeout(function (){

  $('li.splide__slide.relative.product__media-image.slick-slide.slick-active').removeAttr('tabindex');

    },3000);

});


// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function() {
    scrollFunction();
  };
  
  function scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      document.getElementById("back-to-top").style.display = "block";
    } else {
      document.getElementById("back-to-top").style.display = "none";
    }
  }
  
  // When the user clicks on the button, scroll to the top of the document
  document.getElementById("back-to-top").onclick = function() {
    scrollToTop();
  };
  
  function scrollToTop() {
    const scrollStep = -window.scrollY / (500 / 15);
    const scrollInterval = setInterval(function() {
      if (window.scrollY !== 0) {
        window.scrollBy(0, scrollStep);
      } else {
        clearInterval(scrollInterval);
      }
    }, 15);
  }
